/**
 * Created by vladislav on 9/6/2022
 */

const Mobage = function () {
    Platform.call(this, connector.MOBAGE);
};

Mobage.prototype = Object.create(Platform.prototype);
Mobage.prototype.constructor = Mobage;

Mobage.prototype.getLocalStoragePrefix = function () {
    return "_mbga";
};

Mobage.prototype.canSwitchGame = function () {
    return true;
};
